module.exports = __webpack_public_path__ + "img/pngwave.f9411f9c.png";